<div
  class="alert"
  [class.alert-success]="isSuccess()"
  [class.alert-info]="isInfo()"
  [class.alert-warning]="isWarning()"
  [class.alert-danger]="isDanger()"
  (click)="dismissPositive()"
>
  @if (isDismissEnabled()) {
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="dismiss()">
    <span class="material-icons">close</span>
  </button>
  } @if (isSuccess()) {
  <i class="material-icons">check_circle</i>
  } @if (isDanger()) {
  <i class="material-icons">error_outline</i>
  } @if (isInfo()) {
  <i class="material-icons">info_outline</i>
  } @if (isWarning()) {
  <i class="material-icons">warning</i>
  }
  <span [innerHtml]="getSafeHTML(notification.text)"></span>

  @if (hasDetails()) { &nbsp;@if (!isShowDetails) {
  <button class="btn btn-link show-details" (click)="isShowDetails = true">{{ 'notification.details' | translate }}</button>
  } @if (isShowDetails) {
  <div class="details-container">
    <textarea class="details" [ngModel]="notification.details" readonly autosize maxHeight="20.125rem"></textarea>
  </div>
  } }
</div>
